import { api } from '@/api/client'

export interface TopologyNode {
  id: string
  data: {
    label: string
    type: 'domain' | 'alb' | 'target_group' | 'ec2' | 'rds' | 's3'
    status: 'healthy' | 'warning' | 'critical'
    [key: string]: unknown
  }
  position: { x: number; y: number }
}

export interface TopologyEdge {
  id: string
  source: string
  target: string
  data: { status: string; reason?: string; description?: string }
}

export interface HealthScore {
  total: number
  breakdown: {
    alarms: number
    cpu: number
    uptime: number
    errors_5xx: number
  }
  trend?: number | null
}

export interface TopologyResponse {
  nodes: TopologyNode[]
  edges: TopologyEdge[]
  health_score: HealthScore
}

export interface Incident {
  date: string
  alarm_name: string
  summary: string
  severity: 'critical' | 'warning'
}

export interface IncidentsResponse {
  incidents: Incident[]
  summary: { total: number; by_severity: Record<string, number> }
}

export const topologyApi = {
  getTopology: (tenantId: number) =>
    api.get<TopologyResponse>(`/v1/tenants/${tenantId}/infrastructure/topology`).then(r => r.data),

  getIncidents: (tenantId: number, days = 30) =>
    api.get<IncidentsResponse>(`/v1/tenants/${tenantId}/infrastructure/incidents?days=${days}`).then(r => r.data),
}
